var EditorModeManager = require('../../../editor-mode-manager');

module.exports = {
  events: {
    'click .btn-new-item': 'addNewEvent'
  },

  addNewEvent: function () { },

  createTemplate: function () {
    this.$el.find('.btn-new-item').addClass('disabled');
    this.modalData.saveForm(_.bind(this.onFormSaved, this));
  },

  onFormSaved: function (status, data) {
    if (status && data.id) {
      this.modal.close();
      EditorModeManager.setMode(this.mode, data);

      var items = this.extractData([data]);
      var callback = _.bind(this.createCallback, this.tool);
      this.tool.addThumbItem(this.$el, items, callback, 'prepend');
    } else {
      this.$el.find('.btn-new-item').removeClass('disabled');
    }
  },

  render: function () {
    this.$el.html(this.template({
      placeholder: this.filterPlaceholder,
      add_button: this.addButtonText
    }));

    this.$el.find('.antiscroll-inner').addThumb();
  }
};
